'use client'

import { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

if (typeof window !== 'undefined') {
  // DEV-ONLY LAN remap: rewrites a code default of localhost:3000/3010 to the
  // machine's own hostname so a phone/second PC on the LAN can reach the dev
  // backend. This MUST NOT run in production — on Vercel, window.location.hostname
  // is the *app* domain (jobmaster-app.mustautomate.ai), so the remap would point
  // API calls at the app instead of the backend. Gate to local dev hosts only;
  // in production requests use NEXT_PUBLIC_BACKEND_URL untouched.
  const _h = window.location.hostname
  const _isLocalDev = _h === 'localhost' || _h === '127.0.0.1' || _h === 'w11progpu' || /^(10|127|192\.168|172\.(1[6-9]|2\d|3[01]))\./.test(_h)
  if (_isLocalDev) {
    const originalFetch = window.fetch
    window.fetch = function (input, init) {
      if (typeof input === 'string') {
        if (input.startsWith('http://localhost:3010')) {
          const hostname = window.location.hostname
          const protocol = window.location.protocol
          input = input.replace('http://localhost:3010', `${protocol}//${hostname}:3010`)
        } else if (input.startsWith('http://localhost:3000')) {
          const hostname = window.location.hostname
          const protocol = window.location.protocol
          const port = protocol === 'https:' ? '3443' : '3000'
          input = input.replace('http://localhost:3000', `${protocol}//${hostname}:${port}`)
        }
      }
      return originalFetch(input, init)
    }
  }
}
import type { ChildrenType } from '@core/types'

/**
 * React Query (TanStack) QueryClientProvider wrapper for the app.
 *
 * @module D:/WIP/JobMaster_Local_Dev/web/src/components/QueryProvider.tsx
 */
export default function QueryProvider({ children }: ChildrenType) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 min — staleTime throttles refetches; data fetched <1min ago is served from cache
            retry: 1,
            refetchOnWindowFocus: false,  // prevents refetch storms on Supabase WS reconnect
            refetchOnMount: true,         // refetch stale data on remount — needed for Next.js soft-navigation restores
          },
        },
      })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
